import React, { useState, useEffect } from "react";
import Header from "../../Header/Header";
import ProgressBar from "../../../components/ProgressBar";
import GeoSearch from "../../../components/PropertyComponent/GeoSearch";
import styles from "../GeneralInformationForm/GeneralInformationForm.module.css";
import { getAddressComponent } from "../../../helpers/Helper";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
export default function StepTwo() {
    const [formData, setFormData] = useState({
        address: "",
        city: "",
        state: "",
        zipCode: "",
        unitNumber: "",
    });
    const navigate = useNavigate();

    // Storage key for persisting form data
    const STORAGE_KEY = "getQualified_stepTwo";

    // Load saved form data on component mount
    useEffect(() => {
        const savedData = localStorage.getItem(STORAGE_KEY);
        if (savedData) {
            try {
                const parsedData = JSON.parse(savedData);
                setFormData(parsedData);
            } catch (error) {
                console.error("Error parsing saved form data:", error);
            }
        }
    }, []);

    // Save form data whenever it changes
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    }, [formData]);

    const isValidCity = (city) => /^[a-zA-Z\s-]+$/.test(city.trim());

    const handleChange = (e) => {
        if (e.target.name === "city" && !isValidCity(e.target.value)) {
            return;
        } else if (e.target.name === "state" && !isValidCity(e.target.value)) {
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!(await validateForm())) return;
        navigate("/get-qualified/Step-3", { state: formData });
    };
    const validateForm = async () => {
        try {
            return true;
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className="tw-bg-background_color tw-h-[100vh]">
            <Header title="Apply For Financing" />
            <div className="tw-w-full tw-pt-[75px] tw-max-w-[1100px] tw-mx-auto  tw-p-[12px] tw-bg-background_color">
                <ProgressBar currentStep={2} totalSteps={6} />
                <div className="tw-flex tw-justify-center tw-items-center tw-mt-10 ">
                    <div className="tw-w-full max-lg:tw-w-[80%]   tw-bg-background_color">
                        {/* Title Section */}
                        <h2 className="tw-text-2xl tw-font-bold tw-mb-2">Tell Us About Your Home</h2>
                        <p className="tw-text-gray-600 tw-mb-4 tw-text-justify">
                            Every home is unique, and so are its insurance needs. Share key details about your property to receive customized
                            insurance quotes that provide the right level of protection for your specific situation.
                        </p>

                        {/* Form Section */}
                        <form className="tw-space-y-2" onSubmit={handleSubmit}>
                            {/* Property Address */}
                            <div className={styles.fieldContainer}>
                                <label className={styles.fieldLabel}>Property Address</label>
                                <div className="tw-filter-search-wrapper tw-w-full  tw-select-filter max-sm:tw-w-full   tw-rounded-lg tw-text-sm tw-text-gray-700 tw-flex-grow">
                                    <GeoSearch
                                        onBoundingBoxUpdate={(boundingBox, place) => {
                                            console.log(place);
                                            setFormData((prev) => ({
                                                ...prev,
                                                address: place.formatted_address,
                                                city: getAddressComponent(place.address_components, "locality"),
                                                state: getAddressComponent(place.address_components, "administrative_area_level_1"),
                                                zipCode: getAddressComponent(place.address_components, "postal_code"),
                                                unitNumber: getAddressComponent(place.address_components, "subpremise"),
                                            }));
                                        }}
                                        setAddress={(val) => setFormData((prev) => ({ ...prev, address: val }))}
                                        deleteSearchLocation={() => {}}
                                        isSimple={true}
                                        className="tw-w-full "
                                    />
                                </div>
                            </div>

                            {/* City, State, ZIP Code */}
                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
                                <div>
                                    <label className="tw-block tw-font-semibold tw-mb-1">City</label>
                                    <input
                                        type="text"
                                        name="city"
                                        required
                                        value={formData.city}
                                        onChange={handleChange}
                                        placeholder="e.g., New York"
                                        className="tw-w-full tw-border tw-border-gray-200 tw-rounded-md tw-p-2 tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="tw-block tw-font-semibold tw-mb-1">State</label>
                                    <input
                                        type="text"
                                        name="state"
                                        required
                                        value={formData.state}
                                        onChange={handleChange}
                                        placeholder="e.g., NY"
                                        className="tw-w-full tw-border tw-border-gray-200 tw-rounded-md tw-p-2 tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                                    />
                                    {/* <select className="tw-w-full tw-border tw-border-gray-200 tw-rounded-md tw-p-2 tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500">
                                        <option>Select State</option>
                                    </select> */}
                                </div>
                                <div>
                                    <label className="tw-block tw-font-semibold tw-mb-1">ZIP Code</label>
                                    <input
                                        type="number"
                                        name="zipCode"
                                        required
                                        value={formData.zipCode}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 5) {
                                                handleChange(e);
                                            }
                                        }}
                                        placeholder="e.g., 12345"
                                        className="tw-w-full tw-border tw-border-gray-200 tw-rounded-md tw-p-2 tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                                    />
                                </div>
                            </div>

                            {/* Unit Number */}
                            <div>
                                <label className="tw-block tw-font-semibold tw-mb-1">Unit Number (Optional)</label>
                                <input
                                    type="text"
                                    name="unitNumber"
                                    maxLength={10}
                                    value={formData.unitNumber}
                                    onChange={handleChange}
                                    placeholder="Enter your unit number"
                                    className="tw-w-full tw-border tw-border-gray-200 tw-rounded-md tw-p-2 tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                                />
                            </div>

                            {/* Note */}
                            <p className=" tw-text-secondary tw-italic tw-text-[12px] tw-text-justify">
                                Using the address autocomplete feature can save time and ensure accuracy.
                            </p>

                            {/* Submit Button */}
                            <div className="tw-w-full tw-flex tw-justify-center">
                                <button
                                    type="submit"
                                    className="tw-w-fit tw-px-[40px]  tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-py-3 tw-rounded-md tw-font-normal tw-mt-3"
                                >
                                    Next
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
